<!-- 预赛 -->
<template>
    <div class="stage-mod stage-pre-ended">
        <div class="stage-box stage-box--empty">
            <div class="stage-box__msg"><txt-vip-audio /></div>
            <van-button size="big" block type="danger" @click="$toast('初赛成绩还未公布')">初赛成绩生成中</van-button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'pre-ended',
        computed: {
            ...mapGetters(['preRes'])
        }
    }
</script>
